/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDataSetArchiveExportParams } from '../models/CreateDataSetArchiveExportParams';
import type { CreateDataSetFromManifestParams } from '../models/CreateDataSetFromManifestParams';
import type { IngestManifestFromBlobParams } from '../models/IngestManifestFromBlobParams';
import type { JobResponse } from '../models/JobResponse';
import type { PopulateRealAssetDeploymentDataForManifest } from '../models/PopulateRealAssetDeploymentDataForManifest';
import type { RefreshSearchProjectionsParams } from '../models/RefreshSearchProjectionsParams';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class JobService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Job Status
     * @returns JobResponse Lookup an offline job by public ID
     * @throws ApiError
     */
    public getJobStatus({
        jobPublicId,
    }: {
        jobPublicId: string,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/job/{job_public_id}/status',
            path: {
                'job_public_id': jobPublicId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Cancel Job
     * @returns JobResponse Cancel a queued or running job
     * @throws ApiError
     */
    public cancelJob({
        jobPublicId,
    }: {
        jobPublicId: string,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/{job_public_id}/cancel',
            path: {
                'job_public_id': jobPublicId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit a create_data_sets_from_manifest job
     * Submit a create_data_sets_from_manifest job
     * @returns JobResponse Successful Response
     * @throws ApiError
     */
    public submitJobCreateDataSetsFromManifest({
        requestBody,
    }: {
        requestBody: CreateDataSetFromManifestParams,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/create_data_sets_from_manifest',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit a create_data_set_archive_export job
     * Submit a create_data_set_archive_export job
     * @returns JobResponse Successful Response
     * @throws ApiError
     */
    public submitJobCreateDataSetArchiveExport({
        requestBody,
    }: {
        requestBody: CreateDataSetArchiveExportParams,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/create_data_set_archive_export',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit a ingest_manifest_from_blob job
     * Submit a ingest_manifest_from_blob job
     * @returns JobResponse Successful Response
     * @throws ApiError
     */
    public submitJobIngestManifestFromBlob({
        requestBody,
    }: {
        requestBody: IngestManifestFromBlobParams,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/ingest_manifest_from_blob',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit a populate_real_asset_deployment_data_for_manifest job
     * Submit a populate_real_asset_deployment_data_for_manifest job
     * @returns JobResponse Successful Response
     * @throws ApiError
     */
    public submitJobPopulateRealAssetDeploymentDataForManifest({
        requestBody,
    }: {
        requestBody: PopulateRealAssetDeploymentDataForManifest,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/populate_real_asset_deployment_data_for_manifest',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Submit a refresh_search_projections job
     * Submit a refresh_search_projections job
     * @returns JobResponse Successful Response
     * @throws ApiError
     */
    public submitJobRefreshSearchProjections({
        requestBody,
    }: {
        requestBody: RefreshSearchProjectionsParams,
    }): CancelablePromise<JobResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/job/refresh_search_projections',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
